export default "__VITE_ASSET__18da71c4__"